import React, { FC } from 'react'

import styled from 'styled-components'

import { Switch } from '@style-port/roov-ui-components-react'
import { Txt } from 'src/components/atoms'
import { CheckboxWithTxt } from 'src/components/molecules'

const PrefectureContainer = styled.div`
  padding: var(--r0);
  border-radius: var(--r-2);
`

type Props = {
  selectedPrefectures: string[]
  updatePrefectures: (prefectures: string[]) => void
  className?: string
}

type AreaType = {
  name: string
  prefectures: string[]
}

export const ProjectSearchArea: FC<Props> = ({
  selectedPrefectures,
  updatePrefectures,
  className,
}) => {
  const areas: AreaType[] = [
    { name: '北海道', prefectures: ['北海道'] },
    { name: '東北', prefectures: ['青森', '岩手', '宮城', '秋田', '山形', '福島'] },
    {
      name: '甲信越・北陸',
      prefectures: ['新潟', '富山', '石川', '福井', '山梨', '長野'],
    },
    {
      name: '関東',
      prefectures: ['東京都', '神奈川', '埼玉', '千葉', '茨城', '栃木', '群馬'],
    },
    { name: '東海', prefectures: ['愛知', '三重', '岐阜', '静岡'] },
    { name: '関西', prefectures: ['大阪', '京都', '兵庫', '滋賀', '奈良', '和歌山'] },
    { name: '四国', prefectures: ['徳島', '香川', '愛媛', '高知'] },
    { name: '中国', prefectures: ['鳥取', '島根', '岡山', '広島', '山口'] },
    {
      name: '九州・沖縄',
      prefectures: ['福岡', '佐賀', '長崎', '熊本', '大分', '宮崎', '鹿児島', '沖縄'],
    },
  ]

  const isAllSelectedAreaPrefecture = (area: AreaType) => {
    return area.prefectures.every(prefecture => selectedPrefectures.includes(prefecture))
  }

  const isSomeSelectedAreaPrefecture = (area: AreaType) => {
    return area.prefectures.some(prefecture => selectedPrefectures.includes(prefecture))
  }

  const handleOnClickArea = (selectedArea: AreaType) => {
    if (isAllSelectedAreaPrefecture(selectedArea)) {
      updatePrefectures(selectedPrefectures.filter(p => !selectedArea.prefectures.includes(p)))
    } else {
      updatePrefectures([...selectedPrefectures, ...selectedArea.prefectures])
    }
  }

  const handleOnClickPrefecture = (prefecture: string) => {
    if (selectedPrefectures.includes(prefecture)) {
      updatePrefectures(selectedPrefectures.filter(p => p !== prefecture))
    } else {
      updatePrefectures([...selectedPrefectures, prefecture])
    }
  }

  return (
    <div className={className}>
      <Txt sizeType="s" className="tw-text-standardText-secondary">
        エリア
      </Txt>
      <ul className="tw-mt-s-2">
        {areas.map(area => (
          <li key={area.name} className="tw-mt-s-2 first:tw-mt-0">
            <Switch
              switchType={isAllSelectedAreaPrefecture(area) ? 'primary' : 'secondary'}
              onClick={() => handleOnClickArea(area)}
            >
              {area.name}
            </Switch>

            {isSomeSelectedAreaPrefecture(area) && (
              <PrefectureContainer className="tw-mt-s-2 tw-bg-surface-secondary">
                <ul className="tw-flex tw-flex-wrap tw-gap-x-r1 tw-gap-y-r-1 tw-m-0">
                  {area.prefectures.map(prefecture => (
                    <li key={prefecture} className="tw-w-fit">
                      <CheckboxWithTxt
                        text={prefecture}
                        checked={selectedPrefectures.includes(prefecture)}
                        onClick={() => handleOnClickPrefecture(prefecture)}
                      />
                    </li>
                  ))}
                </ul>
              </PrefectureContainer>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
